import React from 'react';
import {
    Box,
    Typography,
    Paper,
} from '@mui/material';
import {
    GridViewOutlined,
    EmojiPeople as MenteeIcon,
    Psychology as MentorIcon,
    AssessmentOutlined,
    Handshake
} from '@mui/icons-material';
import { NavigationSection } from './NavigationSection';

interface MatchingPhaseSidebarProps {
    activeSection: NavigationSection;
    handleSectionChange: (section: NavigationSection) => void;
    isSectionAllowed: (section: NavigationSection) => boolean;
    sidebarCollapsed: boolean;
}

const MatchingPhaseSidebar: React.FC<MatchingPhaseSidebarProps> = ({
    activeSection,
    handleSectionChange,
    isSectionAllowed,
    sidebarCollapsed
}) => {
    return (
        <>
            {!sidebarCollapsed && (
                <Typography variant="subtitle2" sx={{ px: 2, color: 'text.secondary', mb: 1 }}>
                    Matching Phase
                </Typography>
            )}

            <Paper
                elevation={0}
                onClick={() => handleSectionChange(NavigationSection.MATCHING_OVERVIEW)}
                sx={{
                    p: 2,
                    mb: 1,
                    display: 'flex',
                    alignItems: 'center',
                    cursor: isSectionAllowed(NavigationSection.MATCHING_OVERVIEW) ? 'pointer' : 'not-allowed',
                    bgcolor: activeSection === NavigationSection.MATCHING_OVERVIEW ? 'action.selected' : 'transparent',
                    '&:hover': { bgcolor: isSectionAllowed(NavigationSection.MATCHING_OVERVIEW) ? 'action.hover' : 'transparent' },
                    justifyContent: sidebarCollapsed ? 'center' : 'flex-start',
                    opacity: isSectionAllowed(NavigationSection.MATCHING_OVERVIEW) ? 1 : 0.5
                }}
            >
                <GridViewOutlined sx={{ mr: sidebarCollapsed ? 0 : 2, color: 'text.secondary' }} />
                {!sidebarCollapsed && <Typography>Overview</Typography>}
            </Paper>

            <Paper
                elevation={0}
                onClick={() => handleSectionChange(NavigationSection.MENTEE_APPLICANTS)}
                sx={{
                    p: 2,
                    mb: 1,
                    display: 'flex',
                    alignItems: 'center',
                    cursor: isSectionAllowed(NavigationSection.MENTEE_APPLICANTS) ? 'pointer' : 'not-allowed',
                    bgcolor: activeSection === NavigationSection.MENTEE_APPLICANTS ? 'action.selected' : 'transparent',
                    '&:hover': { bgcolor: isSectionAllowed(NavigationSection.MENTEE_APPLICANTS) ? 'action.hover' : 'transparent' },
                    justifyContent: sidebarCollapsed ? 'center' : 'flex-start',
                    opacity: isSectionAllowed(NavigationSection.MENTEE_APPLICANTS) ? 1 : 0.5
                }}
            >
                <MenteeIcon sx={{ mr: sidebarCollapsed ? 0 : 2, color: 'text.secondary' }} />
                {!sidebarCollapsed && <Typography>Mentee Applicants</Typography>}
            </Paper>

            <Paper
                elevation={0}
                onClick={() => handleSectionChange(NavigationSection.MENTOR_APPLICANTS)}
                sx={{
                    p: 2,
                    mb: 1,
                    display: 'flex',
                    alignItems: 'center',
                    cursor: isSectionAllowed(NavigationSection.MENTOR_APPLICANTS) ? 'pointer' : 'not-allowed',
                    bgcolor: activeSection === NavigationSection.MENTOR_APPLICANTS ? 'action.selected' : 'transparent',
                    '&:hover': { bgcolor: isSectionAllowed(NavigationSection.MENTOR_APPLICANTS) ? 'action.hover' : 'transparent' },
                    justifyContent: sidebarCollapsed ? 'center' : 'flex-start',
                    opacity: isSectionAllowed(NavigationSection.MENTOR_APPLICANTS) ? 1 : 0.5
                }}
            >
                <MentorIcon sx={{ mr: sidebarCollapsed ? 0 : 2, color: 'text.secondary' }} />
                {!sidebarCollapsed && <Typography>Mentor Applicants</Typography>}
            </Paper>

            <Paper
                elevation={0}
                onClick={() => handleSectionChange(NavigationSection.SCORES)}
                sx={{
                    p: 2,
                    mb: 1,
                    display: 'flex',
                    alignItems: 'center',
                    cursor: isSectionAllowed(NavigationSection.SCORES) ? 'pointer' : 'not-allowed',
                    bgcolor: activeSection === NavigationSection.SCORES ? 'action.selected' : 'transparent',
                    '&:hover': { bgcolor: isSectionAllowed(NavigationSection.SCORES) ? 'action.hover' : 'transparent' },
                    justifyContent: sidebarCollapsed ? 'center' : 'flex-start',
                    opacity: isSectionAllowed(NavigationSection.SCORES) ? 1 : 0.5
                }}
            >
                <AssessmentOutlined sx={{ mr: sidebarCollapsed ? 0 : 2, color: 'text.secondary' }} />
                {!sidebarCollapsed && <Typography>Scores</Typography>}
            </Paper>

            <Paper
                elevation={0}
                onClick={() => handleSectionChange(NavigationSection.MATCHES)}
                sx={{
                    p: 2,
                    mb: 1,
                    display: 'flex',
                    alignItems: 'center',
                    cursor: isSectionAllowed(NavigationSection.MATCHES) ? 'pointer' : 'not-allowed',
                    bgcolor: activeSection === NavigationSection.MATCHES ? 'action.selected' : 'transparent',
                    '&:hover': { bgcolor: isSectionAllowed(NavigationSection.MATCHES) ? 'action.hover' : 'transparent' },
                    justifyContent: sidebarCollapsed ? 'center' : 'flex-start',
                    opacity: isSectionAllowed(NavigationSection.MATCHES) ? 1 : 0.5
                }}
            >
                <Handshake sx={{ mr: sidebarCollapsed ? 0 : 2, color: 'text.secondary' }} />
                {!sidebarCollapsed && <Typography>Matches</Typography>}
            </Paper>
        </>
    );
};

export default MatchingPhaseSidebar;
